module.exports = __webpack_public_path__ + "static/media/kid-smiling.db814b51.jpg";